/** Search feature — shared constants between API and Web */

export const SEARCH_DEFAULTS = {
  RADIUS_METERS: 10_000,
  PAGE: 1,
  LIMIT: 12,
  PRICE_MIN_CENTS: 0,
  PRICE_MAX_CENTS: 500_000,
  MIN_RATING: 0,
  TIMEZONE: "America/Sao_Paulo",
} as const;

export const SEARCH_LIMITS = {
  RADIUS_METERS_MIN: 1_000,
  RADIUS_METERS_MAX: 50_000,
  PRICE_MAX_CENTS_HARD_LIMIT: 5_000_000,
  MIN_RATING_MIN: 0,
  MIN_RATING_MAX: 5,
  PAGE_LIMIT_MAX: 100,
} as const;

/** Param names as used in the HTTP query string (matches SearchQueryDto) */
export const SEARCH_PARAM_KEYS = {
  LAT: "lat",
  LON: "lon",
  RADIUS_METERS: "radiusMeters",
  CATEGORY: "category",
  START_TIME: "startTime",
  END_TIME: "endTime",
  PRICE_MIN_CENTS: "priceMinCents",
  PRICE_MAX_CENTS: "priceMaxCents",
  MIN_RATING: "minRating",
  GENDER: "gender",
  HAS_DUAL_COMMAND: "hasDualCommand",
  PAGE: "page",
  LIMIT: "limit",
  TIMEZONE: "timezone",
} as const;
